import { render } from "./UserSubscriptionPlansView.vue?vue&type=template&id=2f2aa7aa&scoped=true"
import script from "./UserSubscriptionPlansView.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionPlansView.vue?vue&type=script&lang=js"

import "./UserSubscriptionPlansView.vue?vue&type=style&index=0&id=2f2aa7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2aa7aa"]])

export default __exports__